export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./jackpot-fake.vue?vue&type=template&id=7ecf3a14"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/jackpots/jackpot-fake/jackpot-fake.vue?vue&type=template&id=7ecf3a14
// module id = NV5H
// module chunks = 0